module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="group-overlay"></div>\n<div class="group"></div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/shared/ui/experience/widgets/compositeWidget/CompositeWidgetLayout.tpl
// module id = 1455
// module chunks = 0